export type EventSource =
  | 'getinvolved'
  | 'athletics'
  | 'recreation'
  | 'mason_gross'
  | 'newbrunswick'
  | 'imleagues';

export const EVENT_SOURCE_LABELS: Record<EventSource, string> = {
  getinvolved: 'getINVOLVED',
  athletics: 'Athletics',
  recreation: 'Recreation',
  mason_gross: 'Mason Gross',
  newbrunswick: 'NB Events',
  imleagues: 'IMLeagues',
};

export const EVENT_SOURCE_COLORS: Record<EventSource, string> = {
  getinvolved: 'bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-400',
  athletics: 'bg-orange-100 text-orange-700 dark:bg-orange-900/30 dark:text-orange-400',
  recreation: 'bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400',
  mason_gross: 'bg-purple-100 text-purple-700 dark:bg-purple-900/30 dark:text-purple-400',
  newbrunswick: 'bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-400',
  imleagues: 'bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-400',
};

export interface CampusEvent {
  id: string;
  title: string;
  start_time: string;       // ISO 8601
  end_time: string | null;
  location: string | null;
  host: string | null;
  source: EventSource;
  source_url: string;
  category: string | null;
  image_url: string | null;
  is_free: boolean | null;
  scraped_at: string;
  /** Athletics read enrichment: null/missing means provider precision was not verified. */
  time_confirmed?: boolean | null;
}

export interface EventFilters {
  sources: EventSource[];
  dateRange: 'today' | 'week' | 'month' | 'all';
  search: string;
  category: string | null;
}
